import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { REFRESH_TOKEN, TOKEN, USER_ID } from 'constants/localStorage';

import {
  AUTOTASK_POD_FULL_SIZE,
  CONNECTWISE_POD,
  FRESH_SERVICE_FULL_SIZE,
  FRESH_SERVICE_POD,
  HALO_POD,
  IMPORT_INTEGRATION_POD,
  KASEYA_POD,
  MICROSOFT_365_POD,
  SERVICE_NOW_POD,
  SUPER_OPS_POD,
  SYNCRO_POD,
  ZENDESK_POD,
} from 'router/routes';

import Loader from 'components/Loader';
import { useAppDispatch } from 'hooks/store';
import { changeThemeMode, setPage, setPlatformIframeViewEnabled } from 'store/common';
import { Pages } from 'constants/pages';

const ExternalLogin: React.FC = () => {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const dispatch = useAppDispatch();

  const token = urlParams.get('token');
  const refreshToken = urlParams.get('refreshToken');
  const userId = urlParams.get('userId');
  const itemType = urlParams.get('itemType');
  const itemId = urlParams.get('itemId');
  const psaId = urlParams.get('psaId');
  const psa = urlParams.get('psa');
  const page = urlParams.get('page');

  useEffect(() => {
    if (token && refreshToken && userId) {
      localStorage.setItem(TOKEN, token);
      localStorage.setItem(REFRESH_TOKEN, refreshToken);
      localStorage.setItem(USER_ID, userId);
    }

    if (psaId && psa) {
      dispatch(changeThemeMode('light'));
      dispatch(setPlatformIframeViewEnabled(true));
      if (page === 'secureData') {
        dispatch(setPage(Pages.SecureDataSharing));
      }
      switch (psa) {
        case 'ConnectWise':
          navigate(
            `${CONNECTWISE_POD.replace(':psaId', psaId)}?ticketId=${itemId}&screen=${itemType}`,
          );
          break;
        case 'Autotask':
          navigate(
            `${AUTOTASK_POD_FULL_SIZE.replace(
              ':psaId',
              psaId,
            )}?ticketId=${itemId}&screen=${itemType}`,
          );
          break;
        case 'Halo Service Desk': {
          navigate(`${HALO_POD.replace(':psaId', psaId)}?ticketId=${itemId}&screen=${itemType}`);
          break;
        }
        case 'Kaseya': {
          navigate(`${KASEYA_POD.replace(':psaId', psaId)}?ticketId=${itemId}&screen=${itemType}`);
          break;
        }
        case 'SyncroMsp': {
          navigate(`${SYNCRO_POD.replace(':psaId', psaId)}?ticketId=${itemId}&screen=${itemType}`);
          break;
        }
        case 'SuperOps': {
          navigate(
            `${SUPER_OPS_POD.replace(':psaId', psaId)}?ticketId=${itemId}&screen=${itemType}`,
          );
          break;
        }
        case 'ServiceNow': {
          navigate(
            `${SERVICE_NOW_POD.replace(':psaId', psaId)}?ticketId=${itemId}&screen=${itemType}`,
          );
          break;
        }
        case 'Zendesk': {
          navigate(`${ZENDESK_POD.replace(':psaId', psaId)}?ticketId=${itemId}&screen=${itemType}`);
          break;
        }
        case 'Microsoft 365':
          navigate(
            `${MICROSOFT_365_POD.replace(':psaId', psaId)}?ticketId=${itemId}&screen=${itemType}`,
          );
          break;
        case 'ImportIntegration':
          navigate(
            `${IMPORT_INTEGRATION_POD.replace(':psaId', psaId)}?ticketId=${itemId}&screen=${itemType}`,
          );
          break;
        case 'FreshService':
          navigate(
            `${FRESH_SERVICE_FULL_SIZE.replace(':psaId', psaId)}?ticketId=${itemId}&screen=${itemType}`,
          );
          break;
        default:
          break;
      }
    }
  }, []);

  return <Loader />;
};

export default ExternalLogin;
